import { render, staticRenderFns } from "./InformesComunidad.vue?vue&type=template&id=2a2943ee&"
import script from "./InformesComunidad.vue?vue&type=script&lang=js&"
export * from "./InformesComunidad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports